export default function buildSubmitHandler(onSubmit) {
  return function handleSubmit({ event, schemaVersion }) {
    const eventNameId = event === '_ALL_' ? null : event;
    const schemaVersionId = schemaVersion;

    onSubmit({ eventNameId, schemaVersionId });
  };
}
